"use client";

import { useConfirm } from "@/lib/store/useConfirm";
import { AlertTriangle, X } from "lucide-react";
import { useEffect } from "react";

export function ConfirmDialog() {
  const { isOpen, options, close, resolve } = useConfirm();

  // Dialog açıkken arka plan kaydırmasını kapat
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  const handleConfirm = () => {
    resolve(true);
    useConfirm.setState({ isOpen: false });
  };

  const handleCancel = () => {
    close();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm p-4">
      <div 
        className="w-full max-w-md bg-[#111114] border border-[rgba(201,168,76,0.15)] rounded-2xl shadow-2xl overflow-hidden animate-in fade-in zoom-in-95 duration-200"
        role="dialog"
        aria-modal="true"
      >
        <div className="p-6">
          <div className="flex items-start justify-between mb-4">
            <div className={`w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0 ${options.isDestructive ? 'bg-red-500/10 text-red-500' : 'bg-[#C9A84C]/10 text-[#C9A84C]'}`}>
              <AlertTriangle size={20} />
            </div>
            <button 
              onClick={handleCancel}
              className="text-[#7A7670] hover:text-[#F4F0E8] transition-colors p-1"
            >
              <X size={18} />
            </button>
          </div>
          
          <h2 className="text-lg font-serif text-[#F4F0E8] mb-2">
            {options.title}
          </h2>
          <p className="text-sm text-[#7A7670] leading-relaxed">
            {options.description}
          </p>
        </div>

        <div className="px-6 py-4 bg-black/20 border-t border-[rgba(201,168,76,0.06)] flex justify-end gap-3">
          <button
            onClick={handleCancel}
            className="px-4 py-2 rounded-lg text-sm font-bold uppercase tracking-widest border border-[rgba(201,168,76,0.2)] text-[#7A7670] hover:border-[#C9A84C] hover:text-[#F4F0E8] transition-all"
          >
            {options.cancelText}
          </button>
          <button
            onClick={handleConfirm}
            className={`px-4 py-2 rounded-lg text-sm font-bold uppercase tracking-widest transition-all ${
              options.isDestructive 
                ? "bg-red-500/10 border border-red-500/30 text-red-500 hover:bg-red-500 hover:text-white"
                : "bg-[#C9A84C] text-black hover:bg-[#D4B664]"
            }`}
          >
            {options.confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}
